export default "__VITE_ASSET__7g226v8S__"